module.exports = __webpack_public_path__ + "static/img/H7-b1.cf41416a.jpg";